import api from './api';

const whatsappService = {
  // Config
  getConfig: async () => {
    const response = await api.get('/api/whatsapp-admin/config');
    return response.data;
  },

  updateConfig: async (updates) => {
    const response = await api.put('/api/whatsapp-admin/config', updates);
    return response.data;
  },

  testConfig: async () => {
    const response = await api.get('/api/whatsapp-admin/config/test');
    return response.data;
  },

  // Templates
  getTemplates: async () => {
    const response = await api.get('/api/whatsapp-admin/templates');
    return response.data;
  },

  createTemplate: async (templateData) => {
    const response = await api.post('/api/whatsapp-admin/templates', templateData);
    return response.data;
  },

  updateTemplate: async (id, templateData) => {
    const response = await api.put(`/api/whatsapp-admin/templates/${id}`, templateData);
    return response.data;
  },

  deleteTemplate: async (id, name) => {
    const response = await api.delete(`/api/whatsapp-admin/templates/${id}?name=${encodeURIComponent(name)}`);
    return response.data;
  },

  // Flows
  getFlows: async () => {
    const response = await api.get('/api/whatsapp-admin/flows');
    return response.data;
  },

  // Image uploads
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/api/whatsapp-admin/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getUploads: async () => {
    const response = await api.get('/api/whatsapp-admin/uploads');
    return response.data;
  },

  deleteUpload: async (filename) => {
    const response = await api.delete(`/api/whatsapp-admin/uploads/${encodeURIComponent(filename)}`);
    return response.data;
  },

  // Conversations
  getAllConversations: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/api/agent/conversations?${query}`);
    return response.data;
  },

  getConversationDetail: async (id) => {
    const response = await api.get(`/api/agent/conversations/detail/${id}`);
    return response.data;
  },

  endConversation: async (phone) => {
    const response = await api.post(`/api/agent/conversations/${phone}/end`);
    return response.data;
  },

  // Complaints
  getComplaints: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/api/agent/complaints?${query}`);
    return response.data;
  },

  updateComplaintStatus: async (id, data) => {
    const response = await api.put(`/api/agent/complaints/${id}/status`, data);
    return response.data;
  },

  addAdminNote: async (id, note) => {
    const response = await api.post(`/api/agent/complaints/${id}/note`, { note });
    return response.data;
  },

  sendAdminReply: async (id, message) => {
    const response = await api.post(`/api/agent/complaints/${id}/reply`, { message });
    return response.data;
  },

  // Campaigns
  getCampaigns: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/api/campaigns?${query}`);
    return response.data;
  },

  getCampaign: async (id) => {
    const response = await api.get(`/api/campaigns/${id}`);
    return response.data;
  },

  createCampaign: async (data) => {
    const response = await api.post('/api/campaigns', data);
    return response.data;
  },

  previewAudience: async (filters) => {
    const response = await api.post('/api/campaigns/preview-audience', filters);
    return response.data;
  },

  sendCampaign: async (id) => {
    const response = await api.post(`/api/campaigns/${id}/send`);
    return response.data;
  },

  cancelCampaign: async (id) => {
    const response = await api.post(`/api/campaigns/${id}/cancel`);
    return response.data;
  },

  deleteCampaign: async (id) => {
    const response = await api.delete(`/api/campaigns/${id}`);
    return response.data;
  },

  // Analytics
  getAnalytics: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/api/agent/analytics?${query}`);
    return response.data;
  },
};

export default whatsappService;
